import Hero from "../../../../components/Hero";
import useCMSApi from "../../hooks/useCMSApi";
import { Footer } from "../../../../components/Footer";
import { useNavigate } from "react-router-dom";

export default function Blogs() {
  const navigate = useNavigate();
  const { pages, loading, error } = useCMSApi();
  const getSlicedParagraph = (htmlContent, charLimit) => {
    if (!htmlContent) return "";

    try {
      // Parse the HTML content
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Select all <p> tags
      const paragraphs = doc.querySelectorAll("p");

      // Find the first meaningful non-empty paragraph
      let meaningfulParagraph = null;
      for (const paragraph of paragraphs) {
        if (paragraph.textContent.trim()) {
          meaningfulParagraph = paragraph;
          break;
        }
      }

      if (!meaningfulParagraph) return ""; // No meaningful paragraph found

      // Get the text content and slice it
      const textContent = meaningfulParagraph.textContent.trim();
      const slicedText = textContent.slice(0, charLimit);

      // Ensure slicing does not cut a word in half
      const finalText =
        slicedText.slice(0, slicedText.lastIndexOf(" ")) + "...";

      return finalText;
    } catch (error) {
      console.error("Error parsing HTML:", error);
      return "";
    }
  };

  return (
    <>
      <Hero bgImage="" imageText={{ title: "Our Blogs" }} />
      <div className=" bg-white m-auto py-5">
        <div className=" grid  gap-3 w-11/12 md:grid-cols-2 lg:grid-cols-3 grid-cols-1">
          {loading && (
            <div className="flex items-center justify-center h-screen w-screen bg-white">
              <div className="w-20 h-20 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
            </div>
          )}
          {error && <div>Something went wrong......</div>}
          {!loading &&
            !error &&
            pages?.map(
              (page) =>
                page.status === "published" && (
                  <div className="p-10 ">
                    <div class="max-w-md mx-auto rounded-2xl overflow-hidden shadow-lg bg-white">
                      <div class="h-48 w-full relative">
                        {page.featuredImages[0] ? (
                          <div className="h-48 w-full relative">
                            <img
                              src={page.featuredImages[0]}
                              alt="Blog Cover"
                              className="h-full w-full object-cover"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-4">
                              <h2 className="text-white text-xl font-semibold">
                                {page.title}
                              </h2>
                            </div>
                          </div>
                        ) : (
                          <div className="h-48 w-full bg-gray-200 flex items-center justify-center px-4">
                            <h2 className="text-gray-800 text-xl font-bold text-center">
                              {page.title}
                            </h2>
                          </div>
                        )}
                      </div>
                      <div class="p-4">
                        <p class="text-gray-700 text-base line-clamp-3">
                          {getSlicedParagraph(page.content, 122)}
                        </p>
                        <div className="text-center">
                      <button
                        id="readMoreBtn"
                        class="mt-4 px-4  underline  text-gray-400 font-medium text-lg rounded hover:text-gray-500 transition duration-200"
                        onClick={() => navigate(`/page/${page.slug}`)}
                      >
                        Read More
                          </button>
                          </div>
                        <div class="mt-4 flex justify-between items-center text-sm text-gray-500">
                          <span></span>
                          <span>
                            {new Date(page.createdAt).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              }
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            )}
        </div>
      </div>
      <Footer className="mt-7 fixed bottom-0" />
    </>
  );
}
